import React from 'react';

export default function useOpenEndDatePicker(
  endDatePickerRef,
  startDate: string,
  endDate: string,
  openDatePickerDelay = 500
) {
  React.useEffect(
    () => {
      let timeoutId = null;

      if (endDatePickerRef.current && startDate && !endDate) {
        const { flatpickr } = endDatePickerRef.current;

        timeoutId = setTimeout(
          () => {
            const monthOfStartDate = new Date(startDate).getMonth();

            flatpickr.changeMonth(monthOfStartDate, false);
            flatpickr.open();
          },
          [openDatePickerDelay]
        );
      }

      return () => timeoutId;
    },
    [startDate, endDate]
  );

  return null;
}



// WEBPACK FOOTER //
// ./src/hooks/useOpenEndDatePicker.js